namespace SorAraBul.Web.Modules {
    export namespace PropertiesPermissions {
        export const Insert = "Properties:Insert";
        export const Update = "Properties:Update";
        export const Delete = "Properties:Delete";
        export const View = "Properties:View";
    }
}
